import { ProductJourneyRelationalMetricPeriodicityEnum } from '../types/ProductJourneyRelationalMetricPeriodicityEnum';

export const getPeriodicityOptions = (periodicity: ProductJourneyRelationalMetricPeriodicityEnum) => {
  let expectationValueLabel = '';
  let expectationValueSymbol = 'º';

  switch (periodicity) {
    case ProductJourneyRelationalMetricPeriodicityEnum.Daily:
      expectationValueLabel = 'dia';
      break;
    case ProductJourneyRelationalMetricPeriodicityEnum.Weekly:
      expectationValueLabel = 'semana';
      expectationValueSymbol = 'ª';
      break;
    case ProductJourneyRelationalMetricPeriodicityEnum.Monthly:
      expectationValueLabel = 'mês';
      break;
    case ProductJourneyRelationalMetricPeriodicityEnum.Quarterly:
      expectationValueLabel = 'trimestre';
      break;
    case ProductJourneyRelationalMetricPeriodicityEnum.Semesterly:
      expectationValueLabel = 'semestre';
      break;
    case ProductJourneyRelationalMetricPeriodicityEnum.Yearly:
      expectationValueLabel = 'ano';
      break;
  }

  return {
    expectationValueLabel,
    expectationValueSymbol,
  };
};
